import { connect } from 'react-redux';
import RequiredToSignUp from './RequiredToSignUp';
import { initializeSignUp } from '../../../modules/SignUp';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../../lib/navigation';

const mapStateToProps = state => ({
  isInitializingSignUp: isLoadingSelector(state, 'initSignUp'),
});


const mapDispatchToProps = dispatch => ({
  initSignUp: () => {
    dispatch(initializeSignUp());
  },
  goToSimOrEsimPage: () => {
     Navigation.dispatch(
      CommonActions.navigate({
        name: 'chooseSimOrEsim',
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequiredToSignUp);
